<template>
  <g-signin-button
    class="btn"
    :params="googleSignInParams"
    @success="onSignInSuccess"
    @error="onSignInError"
  >Ingresar</g-signin-button>
</template>
 
<script>
import { serverBus } from "../main";
import axios from '../apiService/config/axios.js'
var auth2;

export default {
  data() {
    return {
      /**
       * The Auth2 parameters, as seen on
       * https://developers.google.com/identity/sign-in/web/reference#gapiauth2initparams.
       * As the very least, a valid client_id must present.
       * @type {Object}
       */
      googleSignInParams: {
        client_id:
          "131164097423-6e6bvj6dho4ocg69hso5tp8ng3ph0s0b.apps.googleusercontent.com"
      }
    };
  },
  methods: {
    onSignInSuccess(googleUser) {
      // `googleUser` is the GoogleUser object that represents the just-signed-in user.
      // See https://developers.google.com/identity/sign-in/web/reference#users
      const profile = googleUser.getBasicProfile(); // etc etc
      auth2 = gapi.auth2.getAuthInstance();
      let email = googleUser.w3.U3;
      let domain = email.split("@");
      if (domain[1] == "neumomed.com") {
        // this.$store.dispatch('saveUserLogged', profile.ofa);
        this.$store.dispatch("saveUser", profile.ofa); // NOMBRE DEL USUARIO
        this.$store.dispatch("saveEmail", email); // CORREO DEL USUARIO
        this.$store.dispatch("saveProviderId",email);
        this.consultarUsuarioOpenEmr(email, googleUser);
        this.$store.dispatch("saveUserImage", googleUser.w3.Paa); // IMAGEN DEL USUARIO
        this.$router.replace(this.$route.query.redirect || "/HistoriaClinica");

        // this.$router.replace(this.$route.query.redirect || '/HistoriaClinica')
      } else {
        //this.$store.dispatch('saveUserLogged', null);
        googleUser.reloadAuthResponse();
        this.logout(googleUser);
      }
    },
    /**
     * Metodo utilizado para consultar el usuario y id de openEmr para la persona
     * logueada con determinado email de gmail.
     *
     * email_usuario: correo de la persona logueada
     */
    consultarUsuarioOpenEmr(email_usuario, googleUser) {
      axios
        .post("/apoyo_7x24_backend/users/usuarios_openemr", {
          email: email_usuario
        })
        .then(response => {
          this.$store.dispatch("saveUserLogged", response.data.data.username);
          this.$store.dispatch(
            "saveProviderId",
            response.data.data.provider_id
          );
          /**
           * El ingreso a la historia clinica queda condicionado a la existencia del
           * usuario en openEmr. Cuando este software no exista, este metodo quedara
           * obsoleto.
           */

          // this.$router.replace(this.$route.query.redirect || '/HistoriaClinica')
        })
        .catch(error => {
          this.$store.dispatch("saveUserLogged", "");
          this.$store.dispatch("saveProviderId", "");
        });
    },
    logout(googleUser) {
      //you can use promise from v1.1.0 also
      alert("Login fail");
      window.location.reload();
    },
    onSignInError(error) {
      // `error` contains any error occurred.
      location.reload();
    }
  }
};
</script> 
 
<style lang="scss" scoped>
/* .g-signin-button {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 3px;
  background-color: #3c82f7;
  color: #fff;
  box-shadow: 0 3px 0 #0f69ff;
} */
.btn {
  width: 11.146vw;
  user-select: none;
  font-family: Nunito, sans-serif;
  background: none;
  padding: 1.5vh 2.5vw;
  margin-top: 6.7vh;
  font-weight: 600;
  font-size: 1.667vw;
  color: #33ccff;
  border: solid;
  border-color: #33ccff;
  border-radius: 3vw;
  border-width: 0.18vw;
  background-position: center;
  transition: background 0.8s; /* Effecto cuando se hace clic en el botón */
}

.btn:hover {
  background-color: #33ccff;
  color: white;
  outline: none;
  background: #33ccff radial-gradient(circle, transparent 1%, #70ddff 1%)
    center/15000%; /* Effecto cuando se hace clic en el botón */
}

/* Para borrar un border raro que aparecía cuando se hacía clic en el botón*/

.btn:active {
  outline: none;
  border-style: none;
  padding: 1.83vh 2.68vw; /* Al borrar el border se volvía más pequeño el botón entonces se compenza calculando el tamaño del botón mas lo que se pierde borrando el border */
  background-color: #70ddff;
  background-size: 100%;
  border-color: #70ddff;
  transition: background 0s; /*Effecto cuando se hace clic en el botón */
}
</style>



// WEBPACK FOOTER //
// src/components/Login-gmail.vue